// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.right-sidebar {
  width: 366px;
  height: 100vh;
  box-sizing: border-box;
  display: block;
}

.sidebar-container {
  height: 100%;
  width: 366px;
  overflow: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  padding: 40px 32px;
  font-size: 12px;
  position: relative;
}

.overlay-background {
  position: absolute;
  left: 0;
  right: 260px;
  top: 0;
  bottom: 0;
  background-color: rgba(128, 128, 128, 0.8);
  z-index: 9989;
}

.developer-country {
  display: flex;
  align-items: center;
}

.developer-country img {
  margin-left: 4px;
  width: 24px !important;
  height: 16px !important;
}

@media only screen and (max-width: 1400px){ 
  .overlay-background{
    right: 260px;
  }
}


.default-sidebar {
  background-color: #fcfcfc;
}

.help-sidebar {
  color: #474747;
  background-color: white;
}

.centered-ctn {
  align-items: center;
}

.center-text {
  text-align: center;
}

.turing-logo-text {
  margin-top: 28px;
  width: 80px;
  height: auto;
  margin-bottom: 60px;
}

.grey-text {
  color: grey;
}

.light-grey-text {
  color: lightgrey;
}

.title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 32px;
}

.sub-title {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 20px;
}

.sidebar-container .turing-text {
  margin-bottom: 20px;
  text-align: center;
  /* width: 175px; */
}

.social-proof {
  display: flex !important;
  flex-direction: column !important;
  padding: 40px 48px !important;
}

.total-developers-hired {

  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #212121;
}

.total-hired-number {
  width: auto;
  height: 105px;
  font-weight: 500;
  font-size: 75px;
  line-height: 140%;
  letter-spacing: -1.5px;
/* Gradients/Gradient Green */
  background: linear-gradient(90deg, #66CC80 0%, #A1DC65 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.developer-testimonial-info {
  display: flex
}

.dev-testimonial-quote {
  margin-bottom: 28px;

  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: #212121;
}

.dev-testimonial-img {
  height: 56px;
  width: 56px;
  border-radius: 40px;
  border: 4px solid #2E6EDF;
}

.developer-info {

  font-size: 12px;
  line-height: 140%;
  letter-spacing: 0.0015em;
  color: #212121;
  margin-left: 12px;
}

.developer-name {
  font-weight: 500;
  font-style: normal;
  font-size: 14px;
  line-height: 160%;
  letter-spacing: 0.15px;
  color: #212121;
}

.social-proof-title {
  font-weight: 500;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  vertical-align: center;
  width: 240px !important;
}

.social-proof-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: auto;
}

.flex-top {
  flex: 1
}

.social-proof-content .slick-initialized {
  width: 366px !important;
}

.social-proof-content .slick-dots {
  display: flex !important;
  justify-content: center;
  top: auto !important;
  bottom: -15px;
  width: 240px !important;
  margin: 0 48px;
  padding-bottom: 10px !important;
  overflow: hidden;
}

.social-proof-content .top-logo,
.social-proof-content .bottom-logo {
  display: flex;
  justify-content: space-evenly;
}


.social-proof-slider-prev {
  margin-left: 32px !important;
  display: flex !important;
  /* width: 250px !important; */
  flex-direction: column-reverse;
  align-items: flex-end;
}

.social-proof-slider-next {
  margin-right: 32px !important;
  display: flex !important;
  /* width: 250px !important; */
  flex-direction: column-reverse;
}

.social-proof-slider-next svg {
  color: #AAAAAA;
}

.social-proof-slider-prev svg:hover, .social-proof-slider-next svg:hover {
  cursor: pointer;
}


.social-proof-content .slick-dots li button:before {
  color: #DDDDDD !important;
  width: 12px !important;
  height: 12px !important;
}

.social-proof-content .slick-dots li {
  margin: 0 2px !important;
}

.social-proof-content .slick-dots  li.slick-active button:before {
  background: #2E6EDF;
  border-radius: 8px;
  color: transparent !important;
  width: 22px !important;
  height: 12px !important;
  top: 2px;
}

.social-proof-content .slick-slider {
  display: flex !important;
  flex: 1;
  padding: 0 18px;
}

.turing-text.grey-text {
  font-size: 12px;
  width: 185px;
}

.sidebar-container .categoried-list {
  list-style: disc;
  padding: 0;
  color: #474747;
  list-style-position: inside;
}

.categoried-list>li {
  margin-bottom: 20px;
}

.help-sidebar .alt-text {
  margin-bottom: 20px;
}

.sidebar-container .panel {
	padding: 20px;
	box-shadow: 0 4px 8px #efefef;
  width: 100%;
}

.panel .description {
  min-height: 0;
  margin-bottom: 0;
  padding: 0;
}

.item-list {
  list-style: disc;
  padding: 0;
  color: #474747;
  list-style-position: inside;
}

.item-list>li {
  margin-bottom: 0;
}

.project-link {
  margin-bottom: 20px;
}

.example-text {
  font-size: 11px;
}

.investors {
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
}

.company-logo {
  margin-right: 20px;
  margin-bottom: 20px;
  height: 15px;
  width: auto;
}

.as-seen-on {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.as-seen-on-social-proof {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.as-seen-on-title {
  color: #888888;
  margin-bottom: 25px;

  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.15px;
}

.facebook-logo {
  height: 10px;
}

.twitter-logo {
  height: 20px;
}

.amazon-logo {
  top: 3px;
  position: relative;
}

.tesla-logo {
  height: 10px;
}

.spacex-logo {
  height: 14px;
  position: relative;
  top: -4px;
}

.forbes-logo {
  width: 82px !important;
  height: 21px !important;
}

.logo-row {
  display: flex;
  justify-content: space-evenly;
  margin-bottom: 38px;
}


.sidebar-full {
  width: 100%;
}

.close-sidebar {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 99999;
}

.country-flag-logo {
  display: inline !important;
}
.logo-1 {
  width: 55px !important;
  height: 27px !important;
}

.logo-2 {
  width: 176px !important;
  height: 29px !important;
}

.logo-3 {
  width: 133px !important;
  height: 27px !important;
}

.logo-4 {
  width: 131px !important;
  height: 18px !important;
}
`, "",{"version":3,"sources":["webpack://./src/v3/components/RightSidebar/rightSidebar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,MAAM;EACN,SAAS;EACT,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;;AAGA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB,6BAA6B;EAC3B,4DAA4D;EAC5D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE;AACF;;AAEA;EACE,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;AACd;;AAEA;EACE;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,6BAA6B;AAC/B;;;AAGA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,OAAO;EACP,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;CACC,aAAa;CACb,6BAA6B;EAC5B,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;;EAEnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB","sourcesContent":[".right-sidebar {\n  width: 366px;\n  height: 100vh;\n  box-sizing: border-box;\n  display: block;\n}\n\n.sidebar-container {\n  height: 100%;\n  width: 366px;\n  overflow: hidden;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  padding: 40px 32px;\n  font-size: 12px;\n  position: relative;\n}\n\n.overlay-background {\n  position: absolute;\n  left: 0;\n  right: 260px;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(128, 128, 128, 0.8);\n  z-index: 9989;\n}\n\n.developer-country {\n  display: flex;\n  align-items: center;\n}\n\n.developer-country img {\n  margin-left: 4px;\n  width: 24px !important;\n  height: 16px !important;\n}\n\n@media only screen and (max-width: 1400px){ \n  .overlay-background{\n    right: 260px;\n  }\n}\n\n\n.default-sidebar {\n  background-color: #fcfcfc;\n}\n\n.help-sidebar {\n  color: #474747;\n  background-color: white;\n}\n\n.centered-ctn {\n  align-items: center;\n}\n\n.center-text {\n  text-align: center;\n}\n\n.turing-logo-text {\n  margin-top: 28px;\n  width: 80px;\n  height: auto;\n  margin-bottom: 60px;\n}\n\n.grey-text {\n  color: grey;\n}\n\n.light-grey-text {\n  color: lightgrey;\n}\n\n.title {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 32px;\n}\n\n.sub-title {\n  font-size: 12px;\n  font-weight: 500;\n  margin-bottom: 20px;\n}\n\n.sidebar-container .turing-text {\n  margin-bottom: 20px;\n  text-align: center;\n  /* width: 175px; */\n}\n\n.social-proof {\n  display: flex !important;\n  flex-direction: column !important;\n  padding: 40px 48px !important;\n}\n\n.total-developers-hired {\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.total-hired-number {\n  width: auto;\n  height: 105px;\n  font-weight: 500;\n  font-size: 75px;\n  line-height: 140%;\n  letter-spacing: -1.5px;\n/* Gradients/Gradient Green */\n  background: linear-gradient(90deg, #66CC80 0%, #A1DC65 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.developer-testimonial-info {\n  display: flex\n}\n\n.dev-testimonial-quote {\n  margin-bottom: 28px;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.dev-testimonial-img {\n  height: 56px;\n  width: 56px;\n  border-radius: 40px;\n  border: 4px solid #2E6EDF;\n}\n\n.developer-info {\n\n  font-size: 12px;\n  line-height: 140%;\n  letter-spacing: 0.0015em;\n  color: #212121;\n  margin-left: 12px;\n}\n\n.developer-name {\n  font-weight: 500;\n  font-style: normal;\n  font-size: 14px;\n  line-height: 160%;\n  letter-spacing: 0.15px;\n  color: #212121;\n}\n\n.social-proof-title {\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 27px;\n  letter-spacing: 0.15px;\n  vertical-align: center;\n  width: 240px !important;\n}\n\n.social-proof-content {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    flex: auto;\n}\n\n.flex-top {\n  flex: 1\n}\n\n.social-proof-content .slick-initialized {\n  width: 366px !important;\n}\n\n.social-proof-content .slick-dots {\n  display: flex !important;\n  justify-content: center;\n  top: auto !important;\n  bottom: -15px;\n  width: 240px !important;\n  margin: 0 48px;\n  padding-bottom: 10px !important;\n  overflow: hidden;\n}\n\n.social-proof-content .top-logo,\n.social-proof-content .bottom-logo {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n\n.social-proof-slider-prev {\n  margin-left: 32px !important;\n  display: flex !important;\n  /* width: 250px !important; */\n  flex-direction: column-reverse;\n  align-items: flex-end;\n}\n\n.social-proof-slider-next {\n  margin-right: 32px !important;\n  display: flex !important;\n  /* width: 250px !important; */\n  flex-direction: column-reverse;\n}\n\n.social-proof-slider-next svg {\n  color: #AAAAAA;\n}\n\n.social-proof-slider-prev svg:hover, .social-proof-slider-next svg:hover {\n  cursor: pointer;\n}\n\n\n.social-proof-content .slick-dots li button:before {\n  color: #DDDDDD !important;\n  width: 12px !important;\n  height: 12px !important;\n}\n\n.social-proof-content .slick-dots li {\n  margin: 0 2px !important;\n}\n\n.social-proof-content .slick-dots  li.slick-active button:before {\n  background: #2E6EDF;\n  border-radius: 8px;\n  color: transparent !important;\n  width: 22px !important;\n  height: 12px !important;\n  top: 2px;\n}\n\n.social-proof-content .slick-slider {\n  display: flex !important;\n  flex: 1;\n  padding: 0 18px;\n}\n\n.turing-text.grey-text {\n  font-size: 12px;\n  width: 185px;\n}\n\n.sidebar-container .categoried-list {\n  list-style: disc;\n  padding: 0;\n  color: #474747;\n  list-style-position: inside;\n}\n\n.categoried-list>li {\n  margin-bottom: 20px;\n}\n\n.help-sidebar .alt-text {\n  margin-bottom: 20px;\n}\n\n.sidebar-container .panel {\n\tpadding: 20px;\n\tbox-shadow: 0 4px 8px #efefef;\n  width: 100%;\n}\n\n.panel .description {\n  min-height: 0;\n  margin-bottom: 0;\n  padding: 0;\n}\n\n.item-list {\n  list-style: disc;\n  padding: 0;\n  color: #474747;\n  list-style-position: inside;\n}\n\n.item-list>li {\n  margin-bottom: 0;\n}\n\n.project-link {\n  margin-bottom: 20px;\n}\n\n.example-text {\n  font-size: 11px;\n}\n\n.investors {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  flex-direction: column;\n}\n\n.company-logo {\n  margin-right: 20px;\n  margin-bottom: 20px;\n  height: 15px;\n  width: auto;\n}\n\n.as-seen-on {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.as-seen-on-social-proof {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n}\n\n.as-seen-on-title {\n  color: #888888;\n  margin-bottom: 25px;\n\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 150%;\n  letter-spacing: 0.15px;\n}\n\n.facebook-logo {\n  height: 10px;\n}\n\n.twitter-logo {\n  height: 20px;\n}\n\n.amazon-logo {\n  top: 3px;\n  position: relative;\n}\n\n.tesla-logo {\n  height: 10px;\n}\n\n.spacex-logo {\n  height: 14px;\n  position: relative;\n  top: -4px;\n}\n\n.forbes-logo {\n  width: 82px !important;\n  height: 21px !important;\n}\n\n.logo-row {\n  display: flex;\n  justify-content: space-evenly;\n  margin-bottom: 38px;\n}\n\n\n.sidebar-full {\n  width: 100%;\n}\n\n.close-sidebar {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 99999;\n}\n\n.country-flag-logo {\n  display: inline !important;\n}\n.logo-1 {\n  width: 55px !important;\n  height: 27px !important;\n}\n\n.logo-2 {\n  width: 176px !important;\n  height: 29px !important;\n}\n\n.logo-3 {\n  width: 133px !important;\n  height: 27px !important;\n}\n\n.logo-4 {\n  width: 131px !important;\n  height: 18px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
